export default __webpack_public_path__ + "static/media/404-dark.9ac254b3.svg";